/**
 * Frases H para input enriquecido.
 */
export function transformPhrasesH(state) {
    if (state.complete_sga.hasOwnProperty('frases_h')) {
        let frases_h = '<p>'
        let field = 'descripcion'
        let type = '0';

        if (state.languaje === 'Español') {
            field = 'descripcion'
        } else if (state.languaje === 'Ingles') {
            field = 'descripcionIngles'
        } else if (state.languaje === 'Portugues') {
            field = 'descripcionPortugues'
        }

        if (state.type === '0') {
            type = 'codigo'
        } else if (state.type === '1') {
            type = '*'
        } else if (state.type === '2') {
            type = ''
        } else if (state.type === '3') {
            type = '<br>'
        } else if (state.type === '4') {
            type = '-'
        }

        state.complete_sga.frases_h.forEach(item => {

            let key = type == 'codigo' ? item.codigo : type;

            if (key != 'NA'){
                if (key == 'NO PELIGROSO'){
                    frases_h += `${item[field]}<br>`;
                } else {
                    frases_h += `<b style="text-align:center;font-family: Arial;">${key}</b> ${item[field]}<br>`;
                }

            }

        })

        frases_h += '</p>'
        return frases_h;
    }


}

/**
 * Frases P para input enriquecido.
 */
export function transformPhrasesP(state) {
    if (state.complete_sga.hasOwnProperty('frases_p')) {
        const frasesP_lists = frasepFinish(state.complete_sga.frases_p)
        let frases_p = '<p>'
        let type = '0';

        let field = 'subtitulo'
        if (state.languaje === 'Español') {
            field = 'subtitulo'
        } else if (state.languaje === 'Ingles') {
            field = 'subtituloIngles'
        } else if (state.languaje === 'Portugues') {
            field = 'subtituloPortugues'
        }

        if (state.type == '0') {
            type = 'titulo'
        } else if (state.type == '1') {
            type = '*'
        } else if (state.type == '2') {
            type = ''
        } else if (state.type == '3') {
            type = '<br>'
        } else if (state.type == '4') {
            type = '-'
        }


        frasesP_lists.forEach(item => {
            if (item.frase_p.length) {
                item.frase_p.forEach(i => {
                    let key = type == 'titulo' ? i.titulo : type;
                    frases_p += `<b style="text-align:center;font-family: Arial;">${key}</b> ${i[field]}<br>`;
                })
            }
        })
        frases_p += '</p>'
        return frases_p;
    }

}

/**
 * Frases completas
 */
function frasepFinish(frases_p) {
    let data = []
    frases_p.forEach((item, key) => {
        let frasesP = [];
        data.push({categoria: item.categoria, frase_p: []})
        item.frase_p.forEach(item => {
            frasesP.push(item);
        })
        data[key]['frase_p'] = deleteObjeRepeat(frasesP);
    })
    return data;
}

/**
 * Eliminar frases repetidas.
 */
function deleteObjeRepeat(frasesP) {
    frasesP = frasesP.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t['titulo'] === value['titulo']
            ))
    );
    return frasesP;
}


/**
 * Frases consejos de prudencia
 */
export function phrasesPIsEmpty(){
 return '<p><strong style="text-align: center; font-family: Arial;">P101</strong> Si se necesita consejo médico, tener a mano el envase o la etiqueta.<br /><strong style="text-align: center; font-family: Arial;">P102</strong> Mantener fuera del alcance de los niños.<br /><strong style="text-align: center; font-family: Arial;">P103</strong> Leer la etiqueta antes del uso.<br /><strong style="text-align: center; font-family: Arial;">P202</strong> No manipular la sustancia antes de haber leído y comprendido todas las instrucciones de seguridad<br/><br/></p>'
}
